import { NgSwitch } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ISizeName } from '@df/core/service/client';
import { NDfModuleLoqate } from '@df/module-loqate/df-module-loqate.config';
import { IAddressBasicData } from '@df/session/api/address-book/address';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { RadioComponent } from '../../ui/form/radio';
import { ModalLayoutMiddle2Component } from '../../ui/modal/modal-layout-middle2.component';
import { CheckoutAddressService } from '../checkout-address.service';

export namespace NAddressValidationModal {
    export const modalId = 'address-validation-modal';

    export interface IModalData {
        address: IAddressBasicData;
        addressValidationResult: NDfModuleLoqate.AddressValidationResult;
        onConfirm: (address: IAddressBasicData | boolean) => void;
    }
}

@DfModal({
    id: NAddressValidationModal.modalId,
    position: 'custom',
    config: (sizeId: ISizeName) => ({
        maxWidth: 350,
        modalClass: 'bg-col-w'
    }),
    blockGroup: 'modals',
    priority: 30,
    reopenPolicy: NDfModal.ReopenPolicy.last,
    sizeRestriction: () => ['S', 'M', 'L', 'X']
})
@Component({
    selector: 'address-validation-modal',
    templateUrl: './address-validation-modal.html',
    styleUrls: ['address-validation-modal.scss'],
    standalone: true,
    imports: [ModalLayoutMiddle2Component, RadioGroupDirective, FormsModule, RadioComponent, NgSwitch],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressValidationModalComponent {
    /**
     * Data passed to modal when opening
     */
    private modalData = inject(MODAL_DATA) as NAddressValidationModal.IModalData;

    /**
     * Modal reference
     */
    private modalRef = inject(ModalRef);

    /**
     * Address service
     */
    protected checkoutAddressService = inject(CheckoutAddressService);

    /**
     * Addresses to display
     * first is the original one then go the suggestions
     */
    protected addresses: { data: IAddressBasicData; valid: boolean; id: number }[] = [];

    /**
     * Id of the currently selected address
     */
    protected currentSelection = 0;

    /**
     * Initializer
     */
    ngOnInit() {
        this.addresses = [{ data: this.modalData.address, valid: false, id: -1 }];
        if (this.modalData.addressValidationResult.hasSuggestion) {
            this.addresses.push(...this.modalData.addressValidationResult.matches.map((data, id) => ({ data, valid: true, id })));
            this.currentSelection = 0;
        } else {
            this.currentSelection = -1;
        }
    }

    protected get isInvalid() {
        return !this.modalData.addressValidationResult.hasSuggestion;
    }

    /**
     * Close modal
     */
    protected close() {
        this.modalRef.close();
    }

    /**
     * Confirm selection
     */
    protected confirm() {
        this.modalRef.close();
        this.modalData.onConfirm(this.currentSelection > -1 ? this.addresses.find(i => i.id === this.currentSelection).data : true);
    }

    protected correct() {
        this.modalRef.close();
        this.modalData.onConfirm(false);
    }
}
